import { motion } from 'motion/react';

import styles from './Logos.module.css';

import logo from '../../assets/images/logo.png';
import delo from '../../assets/images/delo.png';
import ncsp from '../../assets/images/ncsp.png';

export const Logos = () => {
  return (
    <motion.div
      initial={{ opacity: 0 }}
      animate={{ opacity: 1 }}
      transition={{ duration: 0.5 }}
      exit={{ opacity: 0 }}
      className={styles.logosWrapper}
    >
      <img src={logo} alt="logo" className={styles.logo} />
      <img src={delo} alt="delo" className={styles.delo} />
      <img src={ncsp} alt="ncsp" className={styles.ncsp} />
    </motion.div>
  );
};
